// CategoryGrid component
const categories = [
  { label: "Quem Somos", icon: "ri-star-line", desc: "1,200+ new arrivals" },
  { label: "Na Mídia", icon: "ri-t-shirt-line", desc: "Dresses, Tops & More" },
];

export default function CategoryGrid() {
  return (
    <section className="py-20 px-6 md:px-16 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs tracking-[0.3em] uppercase text-gray-400 mb-2">Explore</p>
          <h2 className="text-3xl font-light tracking-tight text-black">Por Módulo</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-gray-200">
          {categories.map((cat) => (
            <button
              key={cat.label}
              className="group bg-white flex flex-col items-center justify-center py-10 px-4 hover:bg-black transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-4">
                <i className={`${cat.icon} text-2xl text-black group-hover:text-white transition`}></i>
              </div>
              <span className="text-xs tracking-widest uppercase font-medium text-black group-hover:text-white transition block">
                {cat.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
